import { Link } from 'react-router-dom'
import Seo from '@/components/Seo'
import SiteLayout from '@/components/SiteLayout'
import PageHero from '@/components/PageHero'
import CtaBand from '@/components/CtaBand'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { cardReaders, cardReadersHub } from '@/content/cardReaders'
import { cardImageOf, heroImageOf } from '@/content/applyImages'

export default function CardReadersHubPage() {
  const hub = cardReadersHub

  return (
    <SiteLayout>
      <Seo
        title={hub.seoTitle}
        description={hub.seoDescription}
        path={hub.path}
        image={heroImageOf(hub)}
      />
      <PageHero
        title={hub.title}
        description={hub.intro}
        image={heroImageOf(hub)}
        eyebrow="Hardware"
      />
      <section className="py-16 bg-background">
        <div className="container mx-auto max-w-7xl px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {cardReaders.map((reader) => (
              <Link key={reader.slug} to={reader.path} className="block group">
                <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow">
                  <div className="h-40 bg-slate-50 overflow-hidden relative">
                    <img
                      src={cardImageOf(reader)}
                      alt={reader.name}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                    {reader.recommended && (
                      <Badge className="absolute top-3 left-3 shadow-sm">Suggested</Badge>
                    )}
                  </div>
                  <CardHeader>
                    <CardTitle>{reader.name}</CardTitle>
                    <CardDescription className="line-clamp-3">{reader.intro}</CardDescription>
                  </CardHeader>
                  <CardContent className="pt-0">
                    <div className="flex flex-wrap gap-1.5">
                      {reader.connectivity.map((c) => (
                        <Badge key={c} variant="secondary" className="font-normal">
                          {c}
                        </Badge>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
          <p className="text-center text-muted-foreground mt-12">
            Looking for printers, stands, and kitchen displays?{' '}
            <Link to="/hardware" className="text-primary hover:underline">
              Browse the full hardware catalog
            </Link>
            .
          </p>
        </div>
      </section>
      <CtaBand
        title="Ready to take card payments?"
        description="Connect your Stripe account and pair a Terminal reader with Tillio POS."
      />
    </SiteLayout>
  )
}
